/** Settings → AI's small shared pieces: the Models card, the Providers card and Add a provider use them. */
import { Button } from "@crew/ui/components/button";
import { FieldError } from "@crew/ui/components/field";
import { ArrowDown, ArrowUp } from "lucide-react";
import type { ReactNode } from "react";
import { errorHint } from "../../app/api";

/** Only `children` when `when` holds. */
export function Show({ when, children }: { when: unknown; children: ReactNode }) {
  return when ? children : null;
}

function IconButton({
  label,
  onClick,
  disabled,
  children,
}: {
  label: string;
  onClick: () => void;
  disabled: boolean;
  children: ReactNode;
}) {
  return (
    <Button
      variant="ghost"
      size="icon-sm"
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </Button>
  );
}

/** Up and down arrows: an item's place in a list. */
export function Arrows({
  name,
  up,
  down,
  disabled,
  onMove,
}: {
  name: { up: string; down: string };
  up: boolean;
  down: boolean;
  disabled: boolean;
  onMove: (direction: "up" | "down") => void;
}) {
  return (
    <>
      <IconButton label={name.up} disabled={disabled || !up} onClick={() => onMove("up")}>
        <ArrowUp />
      </IconButton>
      <IconButton label={name.down} disabled={disabled || !down} onClick={() => onMove("down")}>
        <ArrowDown />
      </IconButton>
    </>
  );
}

export function ErrorNote({ error }: { error: unknown }) {
  return error ? <FieldError className="basis-full">{errorHint(error)}</FieldError> : null;
}
